import React from 'react';
import { Link } from 'react-router-dom';
import MobileFooter from './MobileFooter'; // Import the MobileFooter component
import NewsletterSignup from './NewsletterSignup';

const Footer: React.FC = () => {
  return (
    <>
      {/* Desktop Footer */}
      <footer className="bg-primary text-white py-16 px-container-margin hidden md:block">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center gap-2 mb-6">
              <img src="/buildonLogo.png" alt="Buildon" className="h-8 w-auto brightness-0 invert" />
            </div>
            <p className="text-on-primary-container font-body-md text-body-md">Mzansi's most trusted marketplace for vetted construction and professional building services.</p>
          </div>
          <div>
            <h4 className="font-label-bold text-label-bold uppercase tracking-wider mb-6">Platform</h4>
            <ul className="space-y-4 font-body-md text-body-md text-on-primary-container">
              <li><Link className="hover:text-white transition-colors" to="/contractors">Find a Contractor</Link></li>
              <li><Link className="hover:text-white transition-colors" to="/categories">Categories</Link></li>
              <li><Link className="hover:text-white transition-colors" to="/jobs">Jobs</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-label-bold text-label-bold uppercase tracking-wider mb-6">Company</h4>
            <ul className="space-y-4 font-body-md text-body-md text-on-primary-container">
              <li><Link className="hover:text-white transition-colors" to="/about">About Us</Link></li>
              <li><Link className="hover:text-white transition-colors" to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-label-bold text-label-bold uppercase tracking-wider mb-6">Newsletter</h4>
            <p className="text-on-primary-container font-body-md text-body-md mb-4">Stay updated with building tips and expert advice.</p>
            <NewsletterSignup />
          </div>
        </div>
        <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-on-primary-container font-label-md text-label-md">© 2024 Buildon Professional Services. All rights reserved.</p>
          <div className="flex gap-8 text-on-primary-container font-label-md text-label-md">
            <Link className="hover:text-white" to="/privacy-policy">Privacy Policy</Link>
            <Link className="hover:text-white" to="/terms">Terms of Service</Link>
            <Link className="hover:text-white" to="/privacy-policy#cookies">Cookie Settings</Link>
          </div>
        </div>
      </footer>

      {/* Mobile Footer */}
      <MobileFooter />
    </>
  );
};

export default Footer;
